import WebFont from 'webfontloader';
import Hamburger from '../modules/hamburger';
import Choices from 'choices.js';
import Glider from 'glider-js/glider';
import ScrollOut from 'scroll-out';
import Rellax from 'rellax';

export default {
  init() {
    // JavaScript to be fired on all pages
    WebFont.load({
      google: {
        families: ['Encode Sans:400,600,700, 900', 'Open Sans:300, 400'],
      },
      timeout: 4000,
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    var element = document.querySelector('html');
    Hamburger.register('body', {
      onOpen: () => {
        element.style.overflow = 'hidden';
      },
      onClose: () => {
        element.style.overflow = 'auto';
      },
    });

    //Lettura viewport
    let vw = document.body.clientWidth * 0.01;
    document.documentElement.style.setProperty('--vw', `${vw}px`);

    const is_touch_enabled = () => { 
      return ( 'ontouchstart' in window ) ||  
            ( navigator.maxTouchPoints > 0 ) ||  
            ( navigator.msMaxTouchPoints > 0 ); 
    }

    if (!is_touch_enabled()) {
      document.body.classList.toggle('is-not-touchable');
    }

    window.addEventListener('resize', () => {
      // We execute the same script as before
      vw = document.body.clientWidth * 0.01;  
      document.documentElement.style.setProperty('--vw', `${vw}px`);
    });

    // Dropdown Select
    const selectNewsletterList = document.querySelectorAll('.js-select-newsletter');
    selectNewsletterList.forEach(element => {
      new Choices(element, {
        searchEnabled: false,
      });

      element.addEventListener('choice', sel => {
        let choice = sel.detail.choice.value.toLowerCase();
        if (choice == 'si') {
          document.querySelector('.Newsletter__FormItem--Iva').classList.add('active')
        } else {
          document.querySelector('.Newsletter__FormItem--Iva').classList.remove('active')
        }
      })
    });
    
    // Glider Slider Home 
    if(vw <= 676 && is_touch_enabled()){      
      const loadedIntervalId = setInterval(() => {
        const logoSlider = document.querySelector('.js-logocarousel');
        if(logoSlider){
          new Glider(logoSlider, {
            slidesToShow: 2,
            slidesToScroll: 1,
            draggable: true,
            arrows: {
                prev: document.querySelector('.LogoCarousel__SliderPrev.glider-prev'),
                next: document.querySelector('.LogoCarousel__SliderNext.glider-next'),
            },
            responsive: [
                {
                    breakpoint: 1023,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 676,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    },
                },
            ],
          });
          clearInterval(loadedIntervalId);
        } else {
          const logoSliderContainer = document.querySelector('.LogoCarousel__SliderContainer');
          let sliderPrev = document.createElement('button');
          sliderPrev.setAttribute('role', 'button');
          sliderPrev.setAttribute('aria-label', 'Previous');
          sliderPrev.className = 'LogoCarousel__SliderPrev glider-prev';

          let sliderNext = document.createElement('button');
          sliderNext.setAttribute('role', 'button');
          sliderNext.setAttribute('aria-label', 'Next');
          sliderNext.className = 'LogoCarousel__SliderNext glider-next';
          
          logoSliderContainer.appendChild(sliderPrev);
          logoSliderContainer.appendChild(sliderNext);

          const logoSliderSlider = document.querySelector('.LogoCarousel__Slider');

          logoSliderContainer.classList.add('glider-contain');
          logoSliderSlider.classList.add('glider', 'js-logocarousel');

        }
      }, 100);
    } else {
      const logoSlider = document.querySelector('.js-logocarousel');
      if (logoSlider) {
        new Glider(logoSlider, {
          slidesToShow: 2,
          slidesToScroll: 1,
          draggable: true,
          arrows: {
              prev: document.querySelector('.LogoCarousel__SliderPrev.glider-prev'),
              next: document.querySelector('.LogoCarousel__SliderNext.glider-next'),
          },
          responsive: [
              {
                  breakpoint: 1023,
                  settings: {
                      slidesToShow: 5,
                      slidesToScroll: 1,
                  },
              },
              {
                  breakpoint: 676,
                  settings: {
                      slidesToShow: 3,
                      slidesToScroll: 1,
                  },
              },
          ],
        });
      }
    }

    //CTA SERVIZI CALL
    const popups = document.querySelectorAll('.js-popup');
    if (popups) {
      const divElement = document.createElement('div');
      divElement.classList = 'CtaLightbox';
      const targetElement = document.body;
      targetElement.append(divElement);
      popups.forEach(popup => {
        popup.addEventListener('click', e => {
          e.preventDefault();
            divElement.innerHTML = `
              <div class="CtaLightbox__Box">
                <a href="#" class="CtaLightbox__Close js-popup-close">X</a>
                <h3 class="CtaLightbox__Description">${popup.dataset.description}</h3>
                <img src="${popup.dataset.image}">
                <a class="CtaLightbox__ServiceLink btn button-border" href="${popup.dataset.link}">Vai al sito</a>
              </div>
            `;
            divElement.classList.add('is-active');
            const popupClose = document.querySelector('.js-popup-close');
            if (popupClose) {
              const lightbox = document.querySelector('.CtaLightbox.is-active');
              popupClose.addEventListener('click', e => {
                e.preventDefault();
                lightbox.innerHTML = '';
                lightbox.classList.remove('is-active');
              });
            }
        })
      });
    }

      //START ACCORDION KEEP ITEM OPEN
      // const accordions = el => {
      //   let item_headings = document.querySelectorAll(el + ' .accordionItemHeading');
      //   item_headings.forEach( heading => {
      //     heading.addEventListener('click', () => {
      //       heading.parentNode.classList.toggle('is-active')
      //     })
      //   });
      // };
      // accordions('.js-accordion');
      //END ACCORDION
      //START ACCORDION KEEP ITEM OPEN
      const accordions = el => {
        const accordionItems = document.querySelectorAll(el);
        let item_headings = document.querySelectorAll(el + ' .accordionItemHeading');
      
        item_headings.forEach( heading => {
          heading.addEventListener('click', () => {
            if(heading.parentNode.classList.contains('is-active')){
              heading.parentNode.classList.remove('is-active')
            } else {
              accordionItems.forEach( item => {
                item.classList.remove('is-active')
              })
              heading.parentNode.classList.add('is-active')
            }
          })
        });
      };
      accordions('.js-accordion');
      //END ACCORDION

      // Menu mobile
      const submenus = document.querySelectorAll('.js-submenu');
      submenus.forEach(element => {
      element.addEventListener('click', ev => {
      ev.preventDefault();
      document.querySelector('.MenuPanel__MenuNav').classList.toggle('js-has-submenus-open');
      ev.target.closest('.MenuPanel__NavItemWrapper--HasChildren').classList.toggle('is-active');
      })
      });

 
    if(document.querySelector('.ServicesSlider__Slider')) {
      const serviceSlider = new Glider(document.querySelector('.ServicesSlider__Slider'), {
        slidesToShow: 1,
        slidesToScroll: 1,
        draggable: true,
        arrows: {
            prev: document.querySelector('.ServicesSlider__SliderPrev.glider-prev'),
            next: document.querySelector('.ServicesSlider__SliderNext.glider-next'),
        },
        responsive: [
            {
                breakpoint: 676,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
        ],
      });
      let slide = 0
      const slides = serviceSlider.slides.length - serviceSlider.opt.slidesToShow
      setInterval(() => {
        if (serviceSlider.slide === slides) {
          slide = 0
          serviceSlider.scrollItem(slide)
        } else {
          slide = slide + 1
          serviceSlider.scrollItem(slide)
        }
      }, 25000000)
    }


    //TIMELINE
    const timelineSlider = document.querySelector('.Timeline__Slider.glider');
    if (timelineSlider) {      
      timelineSlider.addEventListener('glider-slide-visible', e => {
        let currentSlide = e.detail.slide;
        const dotItemList = document.querySelectorAll('.Timeline__DotItem');
        dotItemList.forEach(item => {
          item.classList.remove('is-active');
          if (currentSlide == item.dataset.slide) {
            item.classList.add('is-active');
          }
        });
      })
      const timelineSliderObjs = new Glider(timelineSlider, {
        slidesToShow: 1,
        draggable: true,
        scrollLock: true,
        arrows: {
          prev: document.querySelector('.Timeline__YearPrev.glider-prev'),
          next: document.querySelector('.Timeline__YearNext.glider-next'),
        },
      });
      const dots = document.querySelectorAll('.Timeline__DotYear, .Timeline__Dot');
      dots.forEach(dot => {
        dot.addEventListener('click', () => {
          timelineSliderObjs.scrollItem(dot.parentNode.dataset.slide, true)
          const dotItemList = document.querySelectorAll('.Timeline__DotItem');
          dotItemList.forEach(item => item.classList.remove('is-active'));
          dot.parentNode.classList.add('is-active');
        })
      });


    }

    // Dropdown Select
    const selectSingleNav = document.querySelectorAll('.js-select-singlenav');
    selectSingleNav.forEach(element => {
      new Choices(element, {
        searchEnabled: false,
        itemSelectText: '',
        shouldSort: false,
      });
      element.addEventListener('choice', sel => {
        window.location.href = sel.detail.choice.value;
      })
    });

    //Animazioni

    //Scrolling News
    const newsExist = document.querySelector('.anim-OnScroll--EaseNews');
    if(newsExist){
      ScrollOut({
        targets: '.anim-OnScroll--EaseNews',
        once: true,
        threshold: 0.1,
      });
    }
   

    //Counter Numbers 
    const counters = document.querySelectorAll('.counter'); 
    const countersExist = document.querySelector('.counters');
    if(countersExist){
      ScrollOut({
        targets: '.anim-OnScroll--RecapCounter',
        onShown: () => {startCounters(counters)},
      });
  
      ScrollOut({
        targets: '.anim-OnScroll--NotableCounter',
        onShown: () => {startCounters(counters)},
      });
  
      const startCounters = counters => {
        counters.forEach(counter => {
            const updateCount = () => {
            const target = +counter.getAttribute('data-target');
            const speed = 300; 
            const count = +counter.innerText;
            let inc = Math.round(target / speed);
            if (inc == 0){ 
              inc = 2;
            }
            if (count < target) {
              counter.innerText = count + inc;
              setTimeout(updateCount, 50);
            } else {
              counter.innerText = target;
            }
          };
          updateCount();
        });
      }
    } 

    //Scrolling Services animation
    const scrollServiceItem = document.querySelector('.anim-OnScroll--ServiceItem');
    if(scrollServiceItem){
      ScrollOut({
        targets: '.anim-OnScroll--ServicesIcon',
        once: true,
        onShown: element => startAnimation(element, 200),
      });
  
      ScrollOut({
        targets: '.anim-OnScroll--ServicesContent',
        once: true,
        onShown: element => startAnimation(element, 200),
      });
  
    }

    const startAnimation = (el, delay) => {
      setTimeout(() => {
        el.classList.add('is-active');
      }, delay);
    }

    // Services Title animation
    const scrollTitleText = document.querySelector('.anim-OnScroll--TitleText');
    if(!(vw <= 676 && is_touch_enabled()) && scrollTitleText) {
      ScrollOut({
        targets: '.anim-OnScroll--TitleText',
        once: false,
      });
    } 

    // Sticky Header
    ScrollOut({
      targets: '.Header',
      onHidden: elementTarget => {
        document.body.classList.add('is-scrolled');
        const imageElement = elementTarget.querySelector('.Header__Logo--Desktop img');
        let scrolledLogo = imageElement.dataset.logoDark;
        imageElement.setAttribute('src', scrolledLogo)
      },
      onShown: (elementTarget) => {
        document.body.classList.remove('is-scrolled'); 
        const imageElement = elementTarget.querySelector('.Header__Logo--Desktop img');
        let fullLogo = imageElement.dataset.logoLight;
        imageElement.setAttribute('src', fullLogo)
      },
    
    });

    // Sticky Header
    ScrollOut({
      targets: '.PageCover',
      cssProps: { 
        visibleY: true,
      },
    });


    //Parallax Highlights animation
    const rellaxHighlight = document.querySelector('.rellaxHighlight');
    const rellaxServiceSlider = document.querySelector('.ServicesSlider');
    
    if((!(vw <= 676 && is_touch_enabled())) && (rellaxHighlight || rellaxServiceSlider )){
      new Rellax('.rellax-down', {
        speed: -1,
        center: true,
        wrapper: null,
        round: true,
        vertical: true,
        horizontal: false,
      });

      new Rellax('.rellax-up', {
        speed: 1,
        center: true,
        wrapper: null,
        round: true,
        vertical: true,
        horizontal: false,
      });
    }


  }, // fine finalized
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js